/* eslint-disable no-debugger */
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import {
  checkGuestToken,
  isUserAuthenticated,
} from "../helpers/auth/authUtils";
import { getCookie } from "../helpers/other/cookies";
import Chat from "./Chat";
import ChatForm from "./ChatForm";
import ChatTitle from "./ChatTitle";
import ForgotPassword from "./ForgotPassword";
import GuestModal from "./GuestModal";
import Login from "./Login";
import Registration from "./Registration";

interface IProps {
  onClick: () => void;
}

const ChatWindow: React.FC<IProps> = (props: IProps) => {
  const [showLogin, setShowLogin] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const isAuthTokenValid = isUserAuthenticated();
  const isGuestTokenValid = () => checkGuestToken();
  const [forgotPasswordToken, setForgotPasswordToken] = useState("");
  const { user, loginMsg } = useSelector((state: RootStateOrAny) => state.Auth);
  const jwtGuestToken = useSelector(
    (state: RootStateOrAny) => state.Auth.jwtGuestToken,
  );

  window.addEventListener(
    "message",
    (e) => {
      if (e.origin === process.env.REACT_APP_WEBCHAT_DEPLOYED_URL) {
        const tokenString = "token=";
        const data = e.data;
        const index = data.indexOf(tokenString);
        if (index > -1) {
          setForgotPasswordToken(data.substring(index + tokenString.length));
          window.parent.postMessage(
            "open",
            process.env.REACT_APP_WEBCHAT_DEPLOYED_URL,
          );
        } else {
          const isOpenWebchatWidget = getCookie("isOpenWebchatWidget");
          window.parent.postMessage(
            isOpenWebchatWidget ? "open" : "close",
            process.env.REACT_APP_WEBCHAT_DEPLOYED_URL,
          );
        }
      }
    },
    false,
  );

  useEffect(() => {
    if (loginMsg === "success") {
      closeLogin();
    }
  }, [loginMsg]);

  // Prikaz modal ako nema tokena
  useEffect(() => {
    if (!jwtGuestToken && !isAuthTokenValid) {
      setShowGuestModal(true);
    }
  }, [jwtGuestToken, isAuthTokenValid]);

  // Sakrij modal ako je gost ulogovan
  useEffect(() => {
    if (jwtGuestToken && !isAuthTokenValid) {
      setShowGuestModal(false);
    }
  }, [jwtGuestToken, isAuthTokenValid]);

  const openLogin = () => {
    setShowGuestModal(false);
    setShowLogin(true);
  };

  const closeLogin = () => {
    setShowLogin(false);
  };

  const openForgotPassword = () => {
    setShowForgotPassword(true);
  };

  const closeForgotPassword = () => {
    setShowForgotPassword(false);
  };

  const openRegistration = () => {
    setShowRegistration(true);
  };

  const closeRegistration = () => {
    setShowRegistration(false);
  };

  const openGuestModal = () => {
    setShowGuestModal(true);
  };

  const closeGuestModal = () => {
    setShowGuestModal(false);
  };

  const handleModal = () => {
    if (showRegistration || showForgotPassword) {
      setShowRegistration(false);
      setShowForgotPassword(false);
    } else {
      if (showGuestModal) {
        setShowGuestModal(false);
        setShowLogin(true);
      } else {
        setShowLogin(!showLogin);
      }
    }
  };

  const showGuestModalFunc = () => {
    if (showLogin || showRegistration || showForgotPassword) {
      return false;
    }
    if (showGuestModal) {
      return true;
    } else {
      if (isGuestTokenValid()) {
        return false;
      }
      if (!isGuestTokenValid() && isAuthTokenValid) {
        return false;
      }
      return true;
    }
  };

  return (
    <div className="d-flex flex-row flex-wrap justify-content-center chat-window">
      {process.env.REACT_LOGIN_WITH_CREDENTIAL &&
        showLogin &&
        !forgotPasswordToken && (
          <Login
            closeLogin={closeLogin}
            openForgotPassword={openForgotPassword}
            openRegistration={openRegistration}
            isGuestTokenValid={isGuestTokenValid()}
            openGuestModal={openGuestModal}
          />
        )}
      {process.env.REACT_LOGIN_WITH_CREDENTIAL &&
        (showForgotPassword || forgotPasswordToken) && (
          <ForgotPassword
            openLogin={openLogin}
            closeForgotPassword={closeForgotPassword}
            forgotPasswordToken={forgotPasswordToken}
            setForgotPasswordToken={setForgotPasswordToken}
          />
        )}
      {process.env.REACT_LOGIN_WITH_CREDENTIAL &&
        showRegistration &&
        !forgotPasswordToken && (
          <Registration
            openLogin={openLogin}
            closeRegistration={closeRegistration}
          />
        )}
      {showGuestModalFunc() && !forgotPasswordToken && (
        <GuestModal closeGuestModal={closeGuestModal} />
      )}
      <ChatTitle
        onClick={props.onClick}
        handleModal={handleModal}
        /* changeLang={changeLang}
        langStatus={langStatus} */
      />
      <Chat />
      <ChatForm
        disabled={!isAuthTokenValid && !isGuestTokenValid()}
        identity={user}
      />
    </div>
  );
};

export default ChatWindow;
